import { render } from "./CircularChart.vue?vue&type=template&id=2b38373e&scoped=true"
import script from "./CircularChart.vue?vue&type=script&lang=js"
export * from "./CircularChart.vue?vue&type=script&lang=js"

import "./CircularChart.vue?vue&type=style&index=0&id=2b38373e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b38373e"]])

export default __exports__